import { t } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

interface StoreSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const StoreSearchInput: React.FC<StoreSearchInputProps> = ({
  value,
  onChange,
  placeholder = t("search_store"),
  className = "",
}) => {
  const { t: tLayout } = useTranslation("layout");
  return (
    <div className={`flex bg-gray-100 rounded-md ${className}`}>
      <div className="flex items-center ltr:pl-3 rtl:pr-3 pointer-events-none rtl:gap-2 ltr:gap-2">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="min-w-[5px] h-[35px] border-r-2 ltr:pl-2 rtl:pr-2 border-gray-300"></div>
      </div>
      <input
        type="text"
        placeholder={tLayout("search_seller")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-md px-4 py-2 outline-none bg-gray-100 h-12 w-full text-left rtl:text-right"
      />
    </div>
  );
};

export default StoreSearchInput;
